import { render, staticRenderFns } from "./EditQueueDialog.vue?vue&type=template&id=13f9a96f"
import script from "./EditQueueDialog.vue?vue&type=script&lang=js"
export * from "./EditQueueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports